import { render, staticRenderFns } from "./editorconfig.vue?vue&type=template&id=bf2b230e&scoped=true&"
import script from "./editorconfig.vue?vue&type=script&lang=js&"
export * from "./editorconfig.vue?vue&type=script&lang=js&"
import style0 from "./editorconfig.vue?vue&type=style&index=0&id=bf2b230e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2b230e",
  null
  
)

export default component.exports